import React from 'react';

type Props = {
  size?: number;
  /** CSS color value for the mark's stroke. Pass 'currentColor' to inherit from a wrapping sx color. */
  color?: string;
};

// Inlined directly as JSX (not imported as a .svg asset) — `frontend/`'s Vite config treats
// .svg imports as SVGR components while this package's own build treats them as URL strings,
// and that mismatch previously broke browser-tests-frontend CI across unrelated test files.
// Source: CIQ_AI-Agent_General_Icon_Outlined_Black.svg (diamond mark + plus + sparkle accent).
export const AgentGeneralIcon: React.FC<Props> = ({ size = 24, color = '#1A202C' }) => (
  <svg fill="none" height={size} viewBox="0 0 80 80" width={size}>
    <g stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={3.56}>
      <path d="M55.73,15.14h17.78" />
      <path d="M64.63,24.03V6.25" />
    </g>
    <path
      d="M64.09,53.38c.18-.5.89-.5,1.08,0l2.45,6.67c.06.16.18.28.34.34l6.67,2.45c.5.18.5.89,0,1.08l-6.67,2.45c-.16.06-.28.18-.34.34l-2.45,6.67c-.18.5-.89.5-1.08,0l-2.45-6.67c-.06-.16-.18-.28-.34-.34l-6.67-2.45c-.5-.18-.5-.89,0-1.08l6.67-2.45c.16-.06.28-.18.34-.34l2.45-6.67Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.67}
    />
    <g stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.96}>
      <rect
        height={39.88}
        rx={3.68}
        ry={3.68}
        transform="translate(-19.01 34.11) rotate(-45)"
        width={39.88}
        x={11.74}
        y={20.06}
      />
      <line x1={5} x2={57.27} y1={40} y2={40} />
      <line x1={31.68} x2={19.67} y1={13.32} y2={40} />
      <line x1={31.68} x2={43.69} y1={13.32} y2={40} />
      <line x1={31.68} x2={43.69} y1={66.35} y2={39.67} />
      <line x1={31.68} x2={19.67} y1={66.35} y2={39.67} />
    </g>
  </svg>
);
